module.exports = __webpack_public_path__ + "media/flavorselect.c068dcb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/cloud/reservation/flavorselect.png
// module id = 870
// module chunks = 2